import styled from 'styled-components';
import { theme } from '../../../theme';

const { colors } = theme;

export const DivColor = styled.div`
  display: flex;
  align-items: center;
`;

export const DivCircle = styled.div<{ color: string }>`
  display: inline-block;
  margin-right: 0.308rem;
  width: 1.078rem;
  height: 1.078rem;
  border-radius: 100%;
  border: 1px solid ${(props) => (props.color === 'White' ? colors.line : 'rgba(0,0,0,0)')};
  background-color: ${(props) => props.color || 'rgba(0,0,0,0)'};
`;
